export default "__VITE_ASSET__BJbkTpxs__"